/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-05 16:51.
 */
const BaseCategoryPage = require( 'base/category-page' );
const Server = require( 'helper/server' );
const { initMenu } = require( 'purchasing-federation/common/config/member-center-menu' );

const listTpl = Handlebars.templates[ 'templates/my_submission_tpl' ];

class MySubmission extends BaseCategoryPage {
  constructor() {
    super( {
      events: {
        'click .list__status-item': 'statusChanged',
        'click .want_contribute': 'wantContribute',
        'click .submission-item-delete': 'deleteSubmission',
        'click .submission-item-edit': 'editSubmission'
      }
    } );
    this.status = undefined;
    this.pageSize = 15;
  }

  async init() {
    const data = initMenu( 'MySubmission', {}, {} );
    this.$el.find( '.list__nav-title' ).html( data.text );
    this.$el.find( '.treeData[name="tree-data"]' ).html( JSON.stringify( data ) );
    super.init();
  }

  search() {
    const requestParams = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      auditStatus: this.status
    };
    this.renderTable( requestParams );
  }

  statusChanged( e ) {
    const el = e.target || e.srcElement;
    const $el = $( el );
    if ($el.hasClass( 'selected' )) {
      return false;
    }
    const { status } = $el.data();
    this.status = status;
    $el.addClass( 'selected' ).siblings().removeClass( 'selected' );
    this.search();
  }

  async renderTable( requestParams ) {
    const spiner = this.$el.find( '.block__content' ).spin();
    try {
      const { data = [], total = 0 } = await Server.getArticleList( requestParams );
      const html = listTpl( {
        _DATA_: data,
        _TOTAL_: total,
        _pageSize_: this.pageSize
      } );
      this.$el.find( '.block__content' ).html( html );
      this.$el.find( '.block__content .total' ).text( total || 0 );
      this.initPagination( total || 0 );
    }catch ( e ) {
      alert( e.responseText || '未知错误' );
    }
    spiner.stop();
  }

  wantContribute() {
    window.open( `/site-ant/#/submission` );
  }

  editSubmission( e ) {
    const el = e.target || e.srcElement;
    const articleId = $( el ).data( 'id' );
    window.open( `/site-ant/#/submission/${ articleId }` );
  }

  deleteSubmission( e ) {
    const el = e.target || e.srcElement;
    const $el = $( el );
    const articleId = $el.data( 'id' );
    ZCY.utils.modal( {
      button: [ '确认', '取消' ],
      type: 'confirm',
      cls: 'as-modal',
      content: [ '删除后将无法恢复，您确定删除吗？' ],
      container: $( '.purchasing-my_submission' ),
      confirm:( $modal )=> {
        Server.deleteArticle( { articleId } ).then( ( res ) => {
          const success = res === true;
          $modal.modal( 'hide' );
          ZCY.utils.modal( {
            type: success ? 'success' : 'error',
            button: [ '确定' ],
            cls: 'as-modal',
            container: $( '.purchasing-my_submission' ),
            content: [ `删除${ success ? '成功' : '失败' }` ]
          } );
          if (success) {
            this.search();
          }
        }, () => {
          $modal.modal( 'hide' );
          ZCY.utils.modal( {
            type: 'error',
            cls: 'as-modal',
            button: [ '确定' ],
            container: $( '.purchasing-my_submission' ),
            content: [ `删除失败` ]
          } );
        } );
      }
    } );
  }
}

module.exports = MySubmission;
